import { render, staticRenderFns } from "./KullaniciDuzenle.vue?vue&type=template&id=72fe83c8&"
import script from "./KullaniciDuzenle.vue?vue&type=script&lang=js&"
export * from "./KullaniciDuzenle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports